import FormSelectBox from '@/views/components/Inputs/FormSelectBox';

import { useGetPercentageValueList } from '../../hooks';

export const ClaimsPercentageValueSelect = ({
  placeholder = 'Percentage/Value',
  label = 'Enter Percentage/Value',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetPercentageValueList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      shouldUseNativeSelect
      labelClass="fw-100"
    />
  );
};
